module.exports = __webpack_public_path__ + "static/media/ic_switch_on.ba3fd247.svg";